import type React from "react";

import { IndustryLeadersTable } from "app/components/React/TopSites/DomainsTable/Table";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { ECategoryLeadersMetricType } from "../category-leaders/CategoryLeaders.types";

import { WebsiteRankingsTabs } from "./WebsiteRankingsTabs";

export const WebsiteRankingsAllPage: React.FC = () => {
    return (
        <FlexColumn gap="24px">
            <WebsiteRankingsTabs selectedTabId={ECategoryLeadersMetricType.CategoryLeadersAll} />
            <IndustryLeadersTable />
        </FlexColumn>
    );
};
